import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { UserActionRoute } from '@mzic/mzic-utils';
@Injectable({
  providedIn: 'root',
})
export class FlowNavigationService {
  constructor(
    private readonly _router: Router,
    private transloco: TranslocoService,
  ) {}
  navigateAfterConfirmation(flow: UserActionRoute): void {
    console.log(`[Flow Navigation] Received flow: ${flow}`);

    if (flow === UserActionRoute.Login) {
      console.log(
        `[Flow Navigation] Navigating to team-selection for Login flow`,
      );
      this._router.navigate(['team-selection']);
    } else if (
      flow === UserActionRoute.Registration ||
      flow === UserActionRoute.PendingRegistration ||
      flow === UserActionRoute.CompleteRegistrationFromLogin
    ) {
      const currentLang = this.transloco.getActiveLang();
      console.log(
        `[Flow Navigation] Navigating to terms page for ${flow} flow`,
      );
      this._router.navigate([
        `${currentLang}/create-account/artist/terms-and-privacy-policy`,
      ]);
    } else {
      console.log(
        `[Flow Navigation] Unknown flow: ${flow}, no navigation performed`,
      );
      // Adicione outras condições conforme necessário
    }
  }
}
